import React, { FC, useState, useCallback, useMemo } from 'react'
import { BannerTop, DialPad, ListSectionHeader, PersonBox, Search } from '../components/elements'
import { PersonType } from '../types'
import { intercomDoorState, intercomListState, intercomLocationState } from '../store/data'
import { useRecoilValue } from 'recoil'
import { ErrorScreen } from './index'
import { useTranslation } from 'react-i18next'
import { Layout } from '../components/common'
import { filterRecipients, groupRecipients } from '../utils/groupRecipients'

const ListScreen: FC = () => {
  const { t } = useTranslation()
  const listState = useRecoilValue(intercomListState)
  const locationState = useRecoilValue(intercomLocationState)
  const doorState = useRecoilValue(intercomDoorState)
  const [list, setList] = useState<PersonType[] | null>(listState)
  const toSearch = useCallback(
    (input: string) => listState && setList(filterRecipients(listState, input)),
    [listState]
  )
  const groups = useMemo(() => (list ? groupRecipients(list) : []), [list])

  return locationState && doorState ? (
    <Layout classes="bg-page">
      <div className="bg-white w-full">
        <BannerTop location={locationState} door={doorState} />
      </div>
      <div className="px-4 pb-5 mt-5 ">
        <Search toSearch={toSearch} />
        {doorState.showDoorCodeInIntercom !== false && <DialPad />}
      </div>
      <div className="grow overflow-auto">
        {groups.map((group) => (
          <section key={group.label ?? '__ungrouped'}>
            {group.label ? <ListSectionHeader label={group.label} /> : null}
            <div
              className={group.label ? 'mb-2 ml-4 border-l-2 border-border py-1 pl-4 pr-4' : 'px-4'}
            >
              {group.people.map((p) => (
                <div key={p.id} className="mb-5">
                  <PersonBox id={p.id} name={p.name} imageSmall={p.imageSmall} />
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </Layout>
  ) : (
    <ErrorScreen error={t('error.disabled')} />
  )
}

export default ListScreen
